module.exports = __webpack_public_path__ + "img/glotto.e7f89a3.webp";